import { render, staticRenderFns } from "./orderselete.vue?vue&type=template&id=6da65afa&scoped=true"
import script from "./orderselete.vue?vue&type=script&lang=js"
export * from "./orderselete.vue?vue&type=script&lang=js"
import style0 from "./orderselete.vue?vue&type=style&index=0&id=6da65afa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da65afa",
  null
  
)

export default component.exports